/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v27.3.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import * as e from "@arcgis/core/symbols/support/jsonUtils";
import * as A from "@arcgis/core/renderers/support/jsonUtils";

var createFeatureCollection = function createFeatureCollection(e) {
  var A = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var l = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "esriGeometryPoint";
  return {
    layerDefinition: e,
    featureSet: {
      features: A,
      geometryType: l
    }
  };
},
    createFeatureLayerDefinition = function createFeatureLayerDefinition(e, A) {
  return {
    geometryType: e,
    fields: A
  };
};

window.process_env || (window.process_env = {});

var l = "data:image/jpeg;base64,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",
    t = {
  agsBaseUrl: window.process_env.AGS_BASE_URL || "",
  basemaps: [{
    id: "arcgis-streets",
    title: "Streets"
  }, {
    id: "arcgis-streets-night",
    title: "Streets (Night)"
  }, {
    id: "clarityImagery",
    title: "Imagery (Clarity)"
  }, {
    id: "arcgis-imagery",
    title: "Imagery with Labels"
  }, {
    id: "arcgis-light-gray",
    title: "Light Gray Canvas"
  }, {
    id: "arcgis-dark-gray",
    title: "Dark Gray Canvas"
  }, {
    id: "arcgis-topographic",
    title: "Topographic"
  }],
  customBasemaps: {
    clarityImagery: {
      baseMapLayers: [{
        url: "https://clarity.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer"
      }],
      title: "Imagery (Clarity)",
      thumbnailUrl: l
    }
  },
  customReportBasemaps: {
    clarityImagery: {
      baseMapLayers: [{
        url: "https://clarity.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer"
      }],
      title: "Imagery (Clarity)",
      thumbnailUrl: l
    },
    reportNone: {
      baseMapLayers: [{
        url: "https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer",
        opacity: .01
      }],
      title: "None",
      thumbnailUrl: "data:image/png;base64,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"
    }
  },
  defaults: {
    basemap: "arcgis-imagery",
    center: [-98.579404, 39.828127],
    zoom: 5,
    extentExpandFactor: 1.5
  },
  features: {
    sampleSites: {
      featureCollection: createFeatureCollection(null, [], "esriGeometryPoint")
    }
  },
  lods: [{
    level: 0,
    resolution: 156543.03392800014,
    scale: 591657527.591555
  }, {
    level: 1,
    resolution: 78271.51696399994,
    scale: 295828763.795777
  }, {
    level: 2,
    resolution: 39135.75848200009,
    scale: 147914381.897889
  }, {
    level: 3,
    resolution: 19567.87924099992,
    scale: 73957190.948944
  }, {
    level: 4,
    resolution: 9783.93962049996,
    scale: 36978595.474472
  }, {
    level: 5,
    resolution: 4891.96981024998,
    scale: 18489297.737236
  }, {
    level: 6,
    resolution: 2445.98490512499,
    scale: 9244648.868618
  }, {
    level: 7,
    resolution: 1222.992452562495,
    scale: 4622324.434309
  }, {
    level: 8,
    resolution: 611.4962262813797,
    scale: 2311162.217155
  }, {
    level: 9,
    resolution: 305.74811314055756,
    scale: 1155581.108577
  }, {
    level: 10,
    resolution: 152.87405657041106,
    scale: 577790.554289
  }, {
    level: 11,
    resolution: 76.43702828507324,
    scale: 288895.277144
  }, {
    level: 12,
    resolution: 38.21851414253662,
    scale: 144447.638572
  }, {
    level: 13,
    resolution: 19.10925707126831,
    scale: 72223.819286
  }, {
    level: 14,
    resolution: 9.554628535634155,
    scale: 36111.909643
  }, {
    level: 15,
    resolution: 4.77731426794937,
    scale: 18055.954822
  }, {
    level: 16,
    resolution: 2.388657133974685,
    scale: 9027.977411
  }, {
    level: 17,
    resolution: 1.1943285668550503,
    scale: 4513.988705
  }, {
    level: 18,
    resolution: .5971642835598172,
    scale: 2256.994353
  }, {
    level: 19,
    resolution: .29858214164761665,
    scale: 1128.497176
  }, {
    level: 20,
    resolution: .14929107082380833,
    scale: 564.248588
  }],
  layers: {
    fields: {
      minLabelScale: 38e3,
      minScale: 25e4,
      maxScale: 1e4
    }
  },
  map: {
    clickTolerance: 3,
    defaultZoomLevel: 17
  },
  symbols: {
    surfaceEventPoints: {
      opacity: .6,
      size: 5
    }
  },
  reportBasemaps: ["streets", "clarityImagery", "reportImagery", "gray", "dark-gray", "topo", "reportNone"]
},
    a = {
  fromJSON: function fromJSON(A) {
    return e.fromJSON(A);
  }
},
    s = {
  fromJSON: function fromJSON(e) {
    return A.fromJSON(e);
  },
  areColorsEqual: function areColorsEqual(e, A) {
    return e.r.toString() === A.r.toString() && e.g.toString() === A.g.toString() && e.b.toString() === A.b.toString();
  },
  getCanvasRendererOptions: function getCanvasRendererOptions(e) {
    var _t$symbols$surfaceEve = t.symbols.surfaceEventPoints,
        A = _t$symbols$surfaceEve.opacity,
        l = _t$symbols$surfaceEve.size;
    return {
      size: l,
      styles: e ? e.map(function (e) {
        return {
          calcFunc: 'const isStringValue = typeof feat.value === "string";if (isStringValue) { return classBreak.displayName === feat.value; }if (i === 0) { return feat.value <= classBreak.upperBound;}else if(i === length - 1) { return classBreak.lowerBound < feat.value;}else { return classBreak.lowerBound < feat.value && feat.value <= classBreak.upperBound;}',
          classBreak: e,
          color: [e.color.r, e.color.g, e.color.b, 255 * A]
        };
      }) : [{
        fillStyle: ""
      }]
    };
  }
},
    r = "iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAMAAAC67D+PAAAABlBMVEXiaBb///8iZRGbAAAAAnRSTlP/AOW3MEoAAAAnSURBVHjaYmCEAQYGOIuRAc6CMRkYYUwGVAJJBkk5khlIBjMCBBgAE8QAW8nidKgAAAAASUVORK5CYIIA",
    createSimpleLineSymbolJSON = function createSimpleLineSymbolJSON(e, A) {
  var l = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "esriSLSSolid";
  return {
    color: e,
    style: l,
    type: "esriSLS",
    width: A
  };
},
    createLabelValueExpression = function createLabelValueExpression(e) {
  return {
    expression: e
  };
},
    i = {
  createPictureFillSymbolJSON: function createPictureFillSymbolJSON(e, A, l, t, a) {
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
    var r = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1;
    var i = arguments.length > 7 ? arguments[7] : undefined;
    var o = arguments.length > 8 ? arguments[8] : undefined;
    var c = arguments.length > 9 ? arguments[9] : undefined;
    var S = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : 0;
    var p = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : 0;
    var y = A ? {
      contentType: l,
      imageData: e
    } : {
      url: e
    };
    return Object.assign(y, {
      height: a,
      type: "esriPFS",
      width: t,
      xoffset: S,
      yoffset: p,
      xscale: s,
      yscale: r,
      outline: createSimpleLineSymbolJSON(i, o, c)
    });
  },
  createPictureMarkerSymbolJSON: function createPictureMarkerSymbolJSON(e, A, l, t, a, s, r) {
    var i = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    var o = A ? {
      contentType: l,
      imageData: e
    } : {
      url: e
    };
    return Object.assign(o, {
      angle: i,
      height: a,
      type: "esriPMS",
      width: t,
      xoffset: s,
      yoffset: r
    });
  },
  createSimpleFillSymbolJSON: function createSimpleFillSymbolJSON(e) {
    var A = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e;
    var l = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var t = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "esriSLSSolid";
    var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "esriSFSSolid";
    return {
      color: e,
      outline: createSimpleLineSymbolJSON(A, l, t),
      style: a,
      type: "esriSFS"
    };
  },
  createSimpleLineSymbolJSON: createSimpleLineSymbolJSON,
  createSimpleMarkerSymbolJSON: function createSimpleMarkerSymbolJSON(e, A) {
    var l = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "esriSMSCircle";
    var t = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [0, 0, 0];
    var r = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1;
    var i = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    return {
      angle: i,
      color: e,
      size: A,
      style: l,
      type: "esriSMS",
      outline: createSimpleLineSymbolJSON(s, r),
      xoffset: t,
      yoffset: a
    };
  },
  createTextSymbolJSON: function createTextSymbolJSON() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [255, 255, 255, 255];
    var A = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Arial";
    var l = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 12;
    var t = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "normal";
    var r = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "bolder";
    var i = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [0, 0, 0, 175];
    var o = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 1;
    var c = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : "center";
    return {
      angle: 0,
      color: e,
      font: {
        family: A,
        size: l,
        style: s,
        weight: r,
        decoration: "none"
      },
      haloColor: i,
      haloSize: o,
      horizontalAlignment: c,
      kerning: !0,
      rightToLeft: !1,
      type: "esriTS",
      verticalAlignment: "middle",
      xoffset: t,
      yoffset: a
    };
  },
  createLabelJSON: function createLabelJSON(e, A, l, t, a, s) {
    return {
      labelExpressionInfo: createLabelValueExpression(A),
      symbol: e,
      fieldInfos: a,
      labelPlacement: l,
      sizeInfo: s,
      where: t
    };
  },
  createLabelValueExpression: createLabelValueExpression
};

export { i as J, s as R, a as S, createFeatureCollection as a, createFeatureLayerDefinition as b, t as c, r as o };